import { Field, Formik } from "formik";
import React, { useEffect } from "react";
import { useState } from "react";
import { isEmpty, values } from "lodash";
import {
  FieldInput,
  FieldDropSide,
  SearchableList,
  FieldInputSSN,
  FieldInputDecimal,
  FieldInputFormatted,
  ManageCensusLayout,
  Link,
  FieldButtonGroup,
  DatePicker,
  LoaderWrapper,
} from "../../../components";
import {
  faTimes,
  faPencilAlt,
  faTrashAlt,
  faTimesCircle,
  faExclamationTriangle,
} from "@fortawesome/pro-light-svg-icons";
import {
  ROUTES,
  MANAGE_CENSUS_ROUTES,
  getAdvancedPathWithParam,
  FLOW_TYPES,
  required,
  OPTIONS_DATA_MAPPER,
  getFormattedZip,
  getFormattedPhone,
  FORM_PLACEHOLDERS,
  manageCensusFormNames,
  formFields,
  getFormattedSsn,
  usDateFormat,
} from "../../../utils";
import { Form, Button, Tabs, Tab, Modal, Col, Row } from "react-bootstrap";
import company from "../../../mocks/company.json";
import { useDeepEffect, useRouterParams, useRequest } from "../../../abstracts";
import {
  getCountriesList,
  getStates,
  getStatesList,
  AddBeneficary,
  getBeneficiaryDetailsById,
  getBeneficiaryDetailsByEmployeeId,
} from "../../../services";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import BankAccountDetailsFields from "../EmployeeInformationContainer/BankAccountDetails";
const AddBeneficairyContainer = (props) => {
  const { history } = props;
  const { censusId, beneficiaryId, flow } = useRouterParams();
  const formName = manageCensusFormNames.BENEFICIARY_DETAILS;
  const fields = formFields[formName];
  const isEdit = flow === FLOW_TYPES.EDIT;
  const isSave = flow === FLOW_TYPES.SAVE;
  const [loading, setLoading] = useState(false);
  const [stateList, setStateList] = useState([]);
  const [countries, setCountries] = useState([]);
  const [initialValues, setInitialValues] = useState({});
  const [beneficiaryDetailsCount, setBeneficiaryDetailsCount] = useState(0);
  const BeneficiaryType = [
    {
      label: "Primary",
      value: 1,
    },
    {
      label: "Contingent",
      value: 2,
    },
  ];
  const RelationshipOptions = [
    {
      label: "Spouse",
      value: 1,
    },
    {
      label: "NonSpouse",
      value: 2,
    },
  ];
  useEffect(() => {
    getCountriesList().then((response) => {
      setCountries(response);
    });
    getStates().then((response) => {
      setStateList(response);
    });
    getBeneficiaryDetailsByEmployeeId(censusId).then((response) => {
      setBeneficiaryDetailsCount(response.length);
    });
    if (beneficiaryId) {
      setLoading(true);
      getBeneficiaryDetailsById(beneficiaryId)
        .then((response) => {
          setInitialValues(response);
          setLoading(false);
        })
        .catch(() => {});
    }
  }, []);
  const onFormSubmit = (values, { setFieldError, setFieldTouched }) => {
    setLoading(true);
    AddBeneficary({
      ...values,
      employeeId: parseInt(censusId, 0),
    })
      .then((response) => {
        if (response.isSuccessfull) {
          setLoading(false);
          history.push(
            getAdvancedPathWithParam({
              path: MANAGE_CENSUS_ROUTES.BENEFICIARY_DETAILS,
              pathParam: [FLOW_TYPES.EDIT, censusId],
            })
          );
        } else {
          setLoading(false);
          for (var i = 0; i < response.errorMessages.length; i++) {
            var _ = response.errorMessages[i];
            setFieldTouched(_.controlName, true);
            setFieldError(_.controlName, `${_.errorCode} : ${_.message}`);
          }
        }
      })
      .catch((ex) => {
        setLoading(false);
      });
  };
  const buttons = [
    {
      link: getAdvancedPathWithParam({
        path: MANAGE_CENSUS_ROUTES.BENEFICIARY_DETAILS,
        pathParam: [FLOW_TYPES.EDIT, censusId],
      }),
      label: "Cancel",
      variant: "secondary",
      type: "button",
      flow: [FLOW_TYPES.ADD, FLOW_TYPES.SAVE],
    },
    {
      label: "Save",
      variant: "primary",
      type: "submit",
      flow: [FLOW_TYPES.ADD],
    },
    {
      label: "Cancel",
      variant: "secondary",
      type: "button",
      flow: [FLOW_TYPES.EDIT],
      //icon: faTimes,
      onClick: () =>
        history.push(
          getAdvancedPathWithParam({
            path: MANAGE_CENSUS_ROUTES.BENEFICIARY_DETAILS,
            pathParam: [FLOW_TYPES.EDIT, censusId],
          })
        ),
    },
    {
      label: "Edit",
      variant: "primary",
      type: "button",
      flow: [FLOW_TYPES.EDIT],
      //icon: faPencilAlt,
      onClick: () =>
        history.push(
          getAdvancedPathWithParam({
            path: MANAGE_CENSUS_ROUTES.ADD_BENEFICIARY,
            pathParam: [FLOW_TYPES.SAVE, censusId, beneficiaryId],
          })
        ),
    },
    // {
    //   label: "",
    //   variant: "link",
    //   type: "button",
    //   flow: [FLOW_TYPES.EDIT],
    //   icon: faTrashAlt,
    //   onClick: () => {
    //     deleteEmployee();
    //   },
    // },
    {
      label: "Save",
      variant: "primary",
      type: "submit",
      flow: [FLOW_TYPES.SAVE],
    },
  ];
  const customBreadCrumbs = [
    {
      label: "Beneficiary Details",
      link: MANAGE_CENSUS_ROUTES.BENEFICIARY_DETAILS,
    },
  ];
  return (
    <>
      <Formik
        initialValues={{
          ...initialValues,
          [fields.beneficiaryType]:
            beneficiaryDetailsCount === 0 ? 1 : initialValues.beneficiaryType,
        }}
        onSubmit={onFormSubmit}
        enableReinitialize
        validateOnChange={false}
        validateOnBlur={false}
      >
        {(formProps) => {
          const {
            handleChange,
            setFieldValue,
            handleSubmit,
            setValues,
            setTouched,
            values,
            setSubmitting,
            setFieldError,
            fieldValue,
            ...rest
          } = formProps;
          const onDaySelected = (fieldName, value) => {
            setFieldValue(fieldName, value);
          };
          return (
            <LoaderWrapper isLoading={loading}>
              <Form
                autoComplete="off"
                className="h-100"
                onSubmit={handleSubmit}
                validated={!isEmpty(rest.errors)}
              >
                <ManageCensusLayout
                  layoutHeader="Beneficiary Information"
                  pageFlow={flow}
                  buttons={buttons}
                  customBreadCrumbs={customBreadCrumbs}
                >
                  <div
                    className="w-100 maintenance-container"
                    style={{ paddingRight: "10px" }}
                  >
                    <Field
                      size="sm"
                      isRequired
                      name={fields.beneficiaryType}
                      label={"Beneficiary Type"}
                      options={BeneficiaryType}
                      selectedValue={values[fields.beneficiaryType]}
                      value={values[fields.beneficiaryType]}
                      onChange={(value) => {
                        setFieldValue(fields.beneficiaryType, value);
                      }}
                      component={FieldButtonGroup}
                      //disabled={isEdit && !isSave}
                      disabled={
                        beneficiaryDetailsCount === 0 || (isEdit && !isSave)
                          ? true
                          : false
                      }
                    />
                    <Field
                      size="sm"
                      isRequired
                      name={fields.relationShipType}
                      label={"Relationship"}
                      options={RelationshipOptions}
                      selectedValue={values[fields.relationShipType]}
                      value={values[fields.relationShipType]}
                      onChange={(value) => {
                        setFieldValue(fields.relationShipType, value);
                      }}
                      component={FieldButtonGroup}
                      disabled={isEdit && !isSave}
                    />
                    <Field
                      size="md"
                      isRequired
                      name={fields.beneficiaryName}
                      label="Beneficiary Name"
                      type="text"
                      autoComplete="off"
                      value={values[fields.beneficiaryName]}
                      onChange={handleChange}
                      disabled={isEdit && !isSave}
                      component={FieldInput}
                    />
                    <Field
                      size="md"
                      name={fields.phoneNumber}
                      label={"Phone Number"}
                      type="text"
                      autoComplete="off"
                      value={getFormattedPhone(values[fields.phoneNumber])}
                      onChange={handleChange}
                      disabled={isEdit && !isSave}
                      component={FieldInputFormatted}
                      placeholder={FORM_PLACEHOLDERS.phone}
                      maxLength="12"
                      isRequired
                    />
                    <Field
                      size="md"
                      isRequired
                      name={fields.emailId}
                      label={"Email"}
                      type="text"
                      autoComplete="off"
                      value={values[fields.emailId]}
                      onChange={handleChange}
                      disabled={isEdit && !isSave}
                      component={FieldInput}
                    />
                    <Field
                      isRequired
                      label="Date of Birth"
                      size="md"
                      name={fields.dateOfBirth}
                      value={usDateFormat(values[fields.dateOfBirth])}
                      isDatePicker
                      onClear={() => onDaySelected(fields.dateOfBirth, null)}
                      popupContent={
                        <DatePicker
                          onDayClick={(value) =>
                            onDaySelected(fields.dateOfBirth, value)
                          }
                          value={values[fields.dateOfBirth]}
                        />
                      }
                      component={FieldDropSide}
                      disabled={isEdit && !isSave}
                    />
                    <Field
                      size="md"
                      isRequired
                      name={fields.uniquePersonalIdentification}
                      label={"Social Security Number"}
                      type="text"
                      autoComplete="off"
                      value={getFormattedSsn(
                        values[fields.uniquePersonalIdentification]
                      )}
                      onChange={handleChange}
                      disabled={isEdit && !isSave}
                      component={FieldInputSSN}
                      maxLength="11"
                    />
                    <p className="mt-20 plan-sub-heading">Address Details</p>
                    <Field
                      size="md"
                      name={fields.address1}
                      label={"Address 1"}
                      type="text"
                      autoComplete="off"
                      value={values[fields.address1]}
                      onChange={handleChange}
                      disabled={isEdit && !isSave}
                      component={FieldInput}
                      isRequired
                    />
                    <Field
                      size="md"
                      name={fields.address2}
                      label={"Address 2"}
                      type="text"
                      autoComplete="off"
                      value={values[fields.address2]}
                      onChange={handleChange}
                      disabled={isEdit && !isSave}
                      component={FieldInput}
                    />
                    <Field
                      size="md"
                      name={fields.address3}
                      label={"Address 3"}
                      type="text"
                      autoComplete="off"
                      value={values[fields.address3]}
                      onChange={handleChange}
                      disabled={isEdit && !isSave}
                      component={FieldInput}
                    />
                    <Field
                      size="md"
                      isRequired
                      name={fields.city}
                      label={"City"}
                      type="text"
                      autoComplete="off"
                      value={values[fields.city]}
                      onChange={handleChange}
                      disabled={isEdit && !isSave}
                      component={FieldInput}
                    />
                    <Field
                      size="md"
                      isRequired
                      name={fields.countryId}
                      value={values[fields.countryId]}
                      label="Country"
                      options={
                        countries &&
                        countries.map((country, index) => ({
                          label: country.code,
                          value: country.id,
                        }))
                      }
                      popupContent={
                        <SearchableList
                          label="Select Country"
                          options={
                            countries &&
                            countries.map((country, index) => ({
                              label: country.code,
                              value: country.id,
                            }))
                          }
                          onSelect={(value, label) => {
                            setFieldValue(fields.country, label);
                            setFieldValue(fields.countryId, value);
                            setFieldValue(fields.countryCode, label);
                            setFieldValue(fields.zipCode, null);
                            value == 1 &&
                              setFieldValue(fields.foreignCountry, null) &&
                              setFieldValue(fields.foreignState, null);
                            value == 2 &&
                              setFieldValue(fields.state, null) &&
                              setFieldValue(fields.stateId, null);
                            getStatesList(fields.countryId)
                              .then((response) => {
                                setStateList(response);
                              })
                              .catch((error) => {
                                //Handle error
                              });
                          }}
                          value={values[fields.countryId]}
                          selectedValue={values[fields.countryId]}
                        />
                      }
                      disabled={isEdit && !isSave}
                      component={FieldDropSide}
                    />
                    {values[fields.countryId] == 1 && (
                      <>
                        <Field
                          size="md"
                          isRequired
                          name={fields.stateId}
                          options={
                            stateList &&
                            stateList.map((state, index) => ({
                              label: state.stateDescription,
                              value: state.id,
                            }))
                          }
                          value={values[fields.stateId]}
                          label="State"
                          popupContent={
                            <SearchableList
                              label="Select State"
                              options={
                                stateList &&
                                stateList.map((state, index) => ({
                                  label: state.stateDescription,
                                  value: state.id,
                                }))
                              }
                              onSelect={(value, label) => {
                                setFieldValue(fields.state, label);
                                setFieldValue(fields.stateId, value);
                              }}
                              selectedValue={values[fields.stateId]}
                              height="250px"
                              value={values[fields.stateId]}
                            />
                          }
                          disabled={isEdit && !isSave}
                          component={FieldDropSide}
                        />
                        <Field
                          size="md"
                          isRequired
                          name={fields.zipCode}
                          label={"Zip Code"}
                          type="text"
                          autoComplete="off"
                          onChange={handleChange}
                          disabled={isEdit && !isSave}
                          component={FieldInputFormatted}
                          value={getFormattedZip(values[fields.zipCode])}
                          placeholder={FORM_PLACEHOLDERS.zip}
                          maxLength="10"
                        />
                      </>
                    )}
                    {values[fields.countryId] == 2 && (
                      <>
                        <Field
                          size="md"
                          isRequired
                          name={fields.foreignCountry}
                          label={"Foreign Country"}
                          type="text"
                          autoComplete="off"
                          value={values[fields.foreignCountry]}
                          onChange={handleChange}
                          disabled={isEdit && !isSave}
                          component={FieldInput}
                        />
                        <Field
                          size="md"
                          isRequired
                          name={fields.foreignState}
                          label={"Foreign State"}
                          type="text"
                          autoComplete="off"
                          value={values[fields.foreignState]}
                          onChange={handleChange}
                          disabled={isEdit && !isSave}
                          component={FieldInput}
                        />
                        <Field
                          size="md"
                          isRequired
                          name={fields.zipCode}
                          label={"Foreign Zip Code"}
                          type="text"
                          autoComplete="off"
                          onChange={handleChange}
                          disabled={isEdit && !isSave}
                          component={FieldInput}
                          value={values[fields.zipCode]}
                        />
                      </>
                    )}
                    <BankAccountDetailsFields
                      {...formProps}
                      fields={fields}
                      isEdit={isEdit}
                      isSave={isSave}
                    />
                  </div>
                </ManageCensusLayout>
              </Form>
            </LoaderWrapper>
          );
        }}
      </Formik>
    </>
  );
};

export default AddBeneficairyContainer;
